import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { BnNgIdleService } from 'bn-ng-idle';
import { CookieService } from 'ngx-cookie-service';
import { ConfirmationService } from 'primeng/api';
import { StorageService } from '../services/storage.service';
import { Constants } from '../models/constants';
import { EventMessage, EventType, RedirectRequest } from '@azure/msal-browser';
@Component({
  selector: 'app-prelogin',
  templateUrl: './prelogin.component.html',
  styleUrls: ['./prelogin.component.scss'],
})
export class PreloginComponent implements OnInit {
  title = 'Global Admin';
  public interval :any;
  loggedIn = false;
  displayBasic: boolean=false;
  counter=0;
  subscription: any;
  showDropdown = false;
  constructor(private cookieService: CookieService,
    private authService: MsalService,
    private router: Router,
    private storageService: StorageService,
    private confirmationService: ConfirmationService,
    private bnIdle: BnNgIdleService) {}

  ngOnInit() {
  }
 
  redirectDashboard(){
    this.authService.instance.loginRedirect({ 
      scopes: ['user.read'],
    });
    
}
  logout() {
    this.storageService.logOut(false);
  }

  startCountdown(seconds: number ){
      this.interval = setInterval(() => {
          if (seconds == 0) {
              this.displayBasic = false;
              clearInterval(this.interval);
              this.storageService.unAuthUserFound();
          }
          this.counter=seconds--;
          }, 1000);
       }


    continue(){
      this.displayBasic = false;
      clearInterval(this.interval);
    }
    cancel(){
      this.storageService.unAuthUserFound();
    }
    CheckIdelUsers(){
      this.bnIdle.startWatching(Constants.INACTIVITY_TIMEOUT_IN_MINS*60).subscribe((isTimedOut: boolean) => {
          if (isTimedOut) {
            this.displayBasic = true;
            this.startCountdown(60)
          }
        });
    }
}
function Intials(cString: string) {
  return cString
      ?.split(' ')
      .map((n, i, a) => (i === 0 || i + 1 === a.length ? n[0] : null))
      .join('');
}
interface Role {
  id: number;
  name: string;
}

